export default __webpack_public_path__ + "static/media/misc-books2-1440w.6a4786d0.png";